import { faHistory } from '@fortawesome/free-solid-svg-icons';
import Title from '../components/Title';
import Panel from '../components/Panel';
import { MetaTitle } from '../components/MetaTitle';
import { jobs } from '../lib/constants';

const Work = () => {
  return (
    <div className="">
      <MetaTitle title="Work" />
      <Title text="Work" icon={faHistory} />

      {jobs.map((job) => (
        <Panel key={job.id}>
          <h2 className="text-base leading-none font-semibold mb-1 lg:text-lg">
            {job.role} |{' '}
            {job.company.link ? (
              <a
                href={job.company.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-500"
              >
                {job.company.name}
              </a>
            ) : (
              job.company.name
            )}
          </h2>
          <p>{job.dates}</p>

          <ul className="list-disc ml-4 -mb-2">
            {job.bulletPoints.map((point) => (
              <li className="mb-2" key={JSON.stringify(point)}>
                {point}
              </li>
            ))}
          </ul>
        </Panel>
      ))}
    </div>
  );
};

export default Work;
